export const d165 = 165
export const d255 = 255
export const d347 = 347

export const I24: Date = new Date('2024-01-08')
export const II24: Date = new Date('2024-07-08')

export const I25: Date = new Date('2025-01-06')
export const II25: Date = new Date('2025-07-07')

export const I26: Date = new Date('2026-01-05')
export const II26: Date = new Date('2026-07-06')

export const I27: Date = new Date('2027-01-04')
export const II27: Date = new Date('2027-07-05')
